import { supabase } from './supabase';

export interface DrinkPairingRow {
  drink_id: string;
  name: string;
  drink_type: string | null;
  score: number;
  description: string | null;
  image_url: string | null;
}

// Online-only: calls the new pairing RPC. Safe fallback returns [].
export async function fetchDrinkRecommendations(tobaccoId: string): Promise<DrinkPairingRow[]> {
  if (!tobaccoId) return [];
  try {
    const { data, error } = await supabase.rpc('get_drink_pairings', {
      t_id: tobaccoId
    });
    if (error || !data) return [];
    return data as DrinkPairingRow[];
  } catch (_err) {
    return [];
  }
}

// Minimal online autosuggest for tobaccos using direct query (no local caching).
// Falls back to empty on error. Limits to 8 results.
export async function searchTobaccosOnline(query: string): Promise<Array<{ id: string; name: string; brand?: string }>> {
  const q = (query || '').trim();
  if (q.length < 2) return [];
  try {
    const { data, error } = await supabase
      .from('tobaccos')
      .select('id,name,brand')
      .or(`name.ilike.%${q}%,brand.ilike.%${q}%`)
      .limit(8);
    if (error || !data) return [];
    return data as Array<{ id: string; name: string; brand?: string }>;
  } catch (_err) {
    return [];
  }
}










